import { ApplicationLogin } from '../authentication/models/application-login.interface';

export function sessionIsValid(session: ApplicationLogin | null): boolean {
   return (
      session != null &&
      session.UserId > 0 &&
      session.ExpirationDate != null &&
      new Date(session.ExpirationDate).getTime() > new Date().getTime()
   );
}
